export default __webpack_public_path__ + "static/IMG_1007-582e6aea9215c24f68da79da06e23c5c.jpg";